/** Portal home page: static list of sub-applications (no login). */
const APPS = [
  {
    name: 'Serial Link',
    description: 'Serial terminal, plotter, file sender, CAN Bus, W-Bus, DBC editor and A/C tools.',
    href: 'serial.html',
    icon: 'terminal'
  },
  {
    name: 'CAN Bootloader',
    description: 'Connect to the CAN bus and transfer a binary file to the microcontroller bootloader.',
    href: 'canboot.html',
    icon: 'upload'
  },
  {
    name: 'DBC Editor',
    description: 'Create and edit CAN database (.dbc) files: messages, signals, nodes.',
    href: 'dbceditor.html',
    icon: 'database'
  },
  {
    name: 'A/C System',
    description: 'A/C control and protocol over CAN, with a monitor of sent and received messages.',
    href: 'ac.html',
    icon: 'wind'
  },
  {
    name: 'Webasto Diagnosis',
    description: 'W-Bus heater diagnosis over CAN: live data, identification, errors, component tests, control.',
    href: 'wbusdiag.html',
    icon: 'flame'
  },
  {
    name: 'CAN View',
    description: 'PCAN-View style CAN monitor: receive list, transmit list with cyclic messages, trace.',
    href: 'pcanview.html',
    icon: 'network'
  },
  {
    name: 'ESP32 Flash',
    description: 'Program an ESP32 from a folder with bootloader, partitions and firmware.',
    href: 'esp32.html',
    icon: 'cpu'
  }
];

const grid = document.getElementById('app-grid');
APPS.forEach((a) => {
  const link = document.createElement('a');
  link.className = 'card hub-tile';
  link.href = a.href;
  link.innerHTML = '<i></i><h2></h2><p class="card-desc"></p>';
  link.querySelector('i').setAttribute('data-lucide', a.icon);
  link.querySelector('h2').textContent = a.name;
  link.querySelector('p').textContent = a.description;
  grid.appendChild(link);
});

if (window.lucide) window.lucide.createIcons();
